import { element, string } from 'prop-types';

const PopoverTagPropTypes = {
  position: string,
  background: string,
  left: string,
  marginLeft: string,
  top: string,
  bottom: string,
  content: string,
  label: element,
  width: string,
  colorContent: string,
  paddingContent: string,
  fontSizeContent: string,
};

export default PopoverTagPropTypes;
